// extracted by mini-css-extract-plugin
module.exports = {"icon":"FilterBtn_icon__1pYUN","root":"FilterBtn_root__gNvQo","btn":"FilterBtn_btn__1dHsj"};